// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lCtI","colMin":"styles_colMin__3xopX"};